import React, { useEffect, useState } from "react";

/**
 * Fixed banner when the browser reports no network.
 * Complements API catch toasts — shows even when requests fail silently.
 */
export default function OfflineStatusBanner() {
  const [isOffline, setIsOffline] = useState(
    () => typeof navigator !== "undefined" && !navigator.onLine,
  );

  useEffect(() => {
    const goOffline = () => setIsOffline(true);
    const goOnline = () => setIsOffline(false);

    window.addEventListener("offline", goOffline);
    window.addEventListener("online", goOnline);

    // Sync in case the event fired before listeners attached.
    setIsOffline(!navigator.onLine);

    return () => {
      window.removeEventListener("offline", goOffline);
      window.removeEventListener("online", goOnline);
    };
  }, []);

  if (!isOffline) return null;

  return (
    <div
      className="qv-offline-banner"
      role="status"
      aria-live="assertive"
      aria-atomic="true"
    >
      <span className="qv-offline-banner__dot" aria-hidden="true" />
      You&apos;re offline. Check your internet connection — some features
      won&apos;t work until you&apos;re back online.
    </div>
  );
}
